import { gql } from '@generated/gql';

const createAppointment = gql(`
  mutation CreateAppointment($appointmentType: AppointmentType!, $attribution: AppointmentAttribution) {
    createAppointment(appointmentType: $appointmentType, attribution: $attribution) {
      appointment {
        referrer {
          customer {
            accountNumber
          }
        }
        connector {
          id
          shortId
        }
        controller {
          id
          name
        }
        id
        participants {
          id
          partnerId
          name
        }
        path
        type
      }
      me {
        id
        token
        type
      }
    }
  }
`);

const partnerConnectorList = gql(`
  query partnerConnectors($positionId: String, $appointmentId: ID) {
    partnerConnectors(positionId: $positionId, appointmentId: $appointmentId) {
      connectors {
        id
        businessName
        shortId
        positionId
      }
    }
  }
`);

const navigateRemoteAppointment = gql(`
  mutation NavigateRemoteAppointment($id: ID!, $path: String!) {
    navigateRemoteAppointment(id: $id, path: $path)
  }
`);

const partnerLoginMutation = `
  mutation PartnerLogin($loginInput: LoginInput!) {
    partnerLogin(
        input: $loginInput
    ) {
        accessToken
    }
}`;

const SupportRemoteMutationPartnerInPerson = `mutation SupportRemoteAppointment($id: ID!) {
    supportRemoteAppointment(id: $id) {
      appointment {
        id
        participants {
          id
          name
          partnerId
          type
        }
      }
    }
}`;

const myBaskets = gql(`
  query MyBaskets($filters: MyBasketsFilters!) {
    myBaskets(filters: $filters) {
      baskets {
        id
        monthlyCost {
          currency
          value
        }
        selectedProductTypes
      }
    }
  }
`);

const PartnerProfileShortInformation = gql(`
  query PartnerProfileShortInformation($positionId: ID!) {
    profileShortInfo(positionId: $positionId) {
      ... on PartnerProfileShortInformation {
        name
        partnerPositionId
      }
    }
  }
`);

const referrerDetails = gql(`
  query AttributionDetails($basketId: ID!) {
    attributionDetails(basketId: $basketId) {
        assistant {
            partner {
                positionId
            }
        }
        referrer {
            partner {
                positionId
            }
            partnerManual {
                positionId
            }
            customer {
                accountNumber
            }
            customerManual {
                accountNumber
            }
            sales {
                oktaUsername
            }
            affiliate {
                uswitch {
                    _empty_
                }
            }
            connector {
                id
                shortId
            }
        }
    }
}

`);

export {
  createAppointment,
  navigateRemoteAppointment,
  partnerLoginMutation,
  SupportRemoteMutationPartnerInPerson,
  myBaskets,
  partnerConnectorList,
  PartnerProfileShortInformation,
  referrerDetails,
};
